import React, { useState, useRef, useEffect } from 'react'
import { Model } from 'survey-core'
import { Survey } from 'survey-react-ui'
// import 'survey-core/defaultV2.min.css'

import { useConvertSurvey } from '../hooks/useConvertSurvey'
import { useSubmitAnswers } from '../hooks/useSubmitAnswers'
import 'survey-core/i18n/traditional-chinese'

const Agree = ({
  setAc,
  setTk,
  ac,
  tk,
  pid,
  setIsLoading,
  setCompletionMessage,
  serial_num,
}) => {
  const [myAgreeJson, setMyAgreeJson] = useState(null)
  const choicesOrderRef = useRef({})
  const choiceIndexMapRef = useRef({})
  const bringOptionsMapRef = useRef({})
  useEffect(() => {
    const timeout = setTimeout(() => {
      const isMobile = window.innerWidth <= 576
      if (!isMobile) return

      const observer = new MutationObserver((mutationsList) => {
        for (let mutation of mutationsList) {
          if (mutation.type === 'childList') {
            const rootEl = document.querySelector('.sd-root-modern')
            if (
              rootEl &&
              !rootEl.classList.contains('sd-root-modern--mobile')
            ) {
              rootEl.classList.add('sd-root-modern--mobile')
              console.log('✅ 強制加上 mobile class 避免抖動')
            }
          }
        }
      })

      observer.observe(document.getElementById('root'), {
        childList: true,
        subtree: true,
      })

      // 清除
      return () => observer.disconnect()
    }, 100) // 100ms 後再判斷

    return () => clearTimeout(timeout)
  }, [])

  // 需要登入嗎
  const requiresLogin = {
    login: false,
    title: '驗證碼',
    placeholder: '請輸入驗證碼',
    alert: '請填寫您的手機或信箱',
  }
  const [imagesReadingTime, setImagesReadingTime] = useState(0)
  // 圖片閱讀時間(秒)
  // useEffect(() => {
  //   setImagesReadingTime(3)
  // }, [])

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const agreeSurvey = new Model(myAgreeJson)

  // 問卷編號
  // const pid = pid
  // 跳題 小心複選題要用陣列

  const visibleIfConditionsInit = {
    // 'q1.row0': '{q0} contains 1', // 麵點/小籠包/湯包
    // 'q1.row1': '{q0} contains 2', // 港點飲茶
    // 'q1.row2': '{q0} contains 3', // 粥品
    // 'q1.row3': '{q0} contains 0', // 烤鴨
    // 'q1.row4':
    //   '{q0} contains 4 or {q0} contains 5 or {q0} contains 6 or {q0} contains 7 or {q0} contains 8', // 烤鴨
    q8: '{q7} = 1',
  }

  // const visibleIfConditionsInit = {

  // }
  // const visibleIfConditionsInit = null
  // const pageVisibleIfConditionsInit = null

  // 非必填(從 0 計算)
  // const notRequired = [100]
  const notRequired = [0, 1, 2, 3, 4, 5, 6]

  const mappedRateChoice = null
  // const pageBreakQuestions = ['q6', 'q11', 'q15']
  const pageBreakQuestions = null

  // const triggersConditionsInit = [
  //   {
  //     type: 'complete',
  //     expression:
  //       '({q0} = 1 or {q0} = 2) or ({q1} = 0 or {q1} = 1 or {q1} = 8 or {q1} = 9) or ({q2} = 1 or {q2} = 2) or ({q5} = 0 or {q5} = 1 or {q5} = 2 or {q5} = 3)',
  //     //     expression: `{q3} <> 4 or ({q4} = 16 or {q4} = 20 or {q4} = 21)`,
  //   },
  //   {
  //     type: 'complete',
  //     expression: '{q6} notcontains 0',
  //   },
  // ]
  const triggersConditionsInit = null
  // const pageVisibleIfConditionsInit = null
  // q1 的選項要帶入到 q2
  // key 是來源題目（複選），value 是目標題目（矩陣）
  // bringOptionsMapRef.current = {
  //   q1: 'q2',
  // }

  const convertedSurvey = useConvertSurvey({
    survey: agreeSurvey,
    pid,
    setAc,
    setTk,
    ac,
    tk,
    setMyAgreeJson,
    imagesReadingTime,
    setImagesReadingTime,
    setIsLoading,
    // completedHtml,
    visibleIfConditionsInit,
    notRequired,
    mappedRateChoice,
    pageBreakQuestions,
    requiresLogin,
    triggersConditionsInit,
    serial_num,
    bringOptionsMapRef,
  })

  const newSurvey = new Model(convertedSurvey)
  useEffect(() => {
    console.log('bringOptionsMapRef', bringOptionsMapRef)
  }, [bringOptionsMapRef])

  // 帶入選項
  const questionMappings = {
    q2: 'q3',
  }

  function helpFunction(survey, options) {
    // console.log('survey.getValue(q1)', survey.getValue('q1'))
    // 參考 P231113152849 或 P231101165555 或 P231206105643(政大帶入選項)
    // if (bringOptionsMapRef.current.hasOwnProperty(options.name)) {
    //   // 篩選變下一題的選項
    //   const targetQuestionName = bringOptionsMapRef.current[options.name]
    //   const targetQuestion = survey.getQuestionByName(targetQuestionName)
    //   const sourceQuestion = survey.getQuestionByName(options.name)
    //   let choices = []
    //   if (options.value) {
    //     options.value.forEach(function (choiceValue, index) {
    //       if (typeof choiceValue === 'number') {
    //         const foundChoice = sourceQuestion.choices.find(
    //           (choice) => choice.value === choiceValue
    //         )
    //         const choiceText = foundChoice ? foundChoice.text : choiceValue
    //         choices.push({ value: index, text: choiceText })
    //       } else if (choiceValue === 'other') {
    //         choices.push({
    //           value: index,
    //           text: '其他(上題填寫內容)',
    //         })
    //       } else if (choiceValue === 'none') {
    //         choices.push({
    //           value: index,
    //           text: options.question.noneText,
    //         })
    //       }
    //     })
    //   }
    //   // targetQuestion.showOtherItem = sourceQuestion.isOtherSelected
    //   // targetQuestion.otherText = sourceQuestion.otherText
    //   // targetQuestion.showNoneItem = sourceQuestion.isNoneSelected
    //   // targetQuestion.noneText = sourceQuestion.noneText
    //   targetQuestion.choices = choices
    //   // if (targetQuestionName === 'q24' || targetQuestionName === 'q34') {
    //   //   targetQuestion.minSelectedChoices = choices.length
    //   // }
    //   // targetQuestion.defaultValue = []
    //   // 最後回傳的 order 要改
    //   const order = targetQuestion.visibleChoices
    //   if (order) {
    //     // 將選項順序設為每個選項的索引值
    //     choiceIndexMapRef.current[targetQuestionName] = order.reduce(
    //       (map, choice, index) => {
    //         map[index] = { index: index, title: choice.title }
    //         return map
    //       },
    //       {}
    //     )
    //     // console.log('choiceIndexMapRef', choiceIndexMapRef)
    //   }
    // }
  }

  // const endSurveyMsg = (survey) => {
  //   if (
  //     survey.getValue('q0') === 1 ||
  //     survey.getValue('q0') === 2 ||
  //     survey.getValue('q1') === 0 ||
  //     survey.getValue('q1') === 1 ||
  //     survey.getValue('q1') === 8 ||
  //     survey.getValue('q1') === 9 ||
  //     survey.getValue('q2') === 1 ||
  //     survey.getValue('q2') === 2 ||
  //     survey.getValue('q5') === 0 ||
  //     survey.getValue('q5') === 1 ||
  //     survey.getValue('q5') === 2 ||
  //     survey.getValue('q5') === 3
  //   ) {
  //     setCompletionMessage(endMessage)
  //   } else if (survey.getValue('q6') && !survey.getValue('q6').includes(0)) {
  //     setCompletionMessage(endMessage)
  //   } else {
  //     setCompletionMessage(
  //       `<h4 style='text-align: center'>問卷已成功送出</h4><h4 style='text-align: center'>請按「完成」前往下載 EZChoice 或填寫更多問卷</h4>`
  //     )
  //   }
  // }

  const canShowPrevButtonPages = null

  useSubmitAnswers({
    survey: newSurvey,
    pid,
    ac,
    tk,
    imagesReadingTime,
    setIsLoading,
    helpFunction,
    canShowPrevButtonPages,
    choicesOrderRef,
    choiceIndexMapRef,
    bringOptionsMapRef,
    // endSurveyMsg,
  })

  return (
    <>
      {convertedSurvey ? (
        <Survey model={newSurvey} />
      ) : myAgreeJson ? (
        <Survey model={agreeSurvey} />
      ) : (
        <></>
      )}
    </>
  )
}

export default Agree
